import { COMPONENTS } from '@/pages/scada/utils/constants.js';

export default {
  state: {
    editMode: false,
    showComponentPanel: false,
    showFacilitiesMenu: true,
    scriptChange: true,
    scriptProcess: true,
    property: [],
    propertyAll: [],
    activeFlanges: [],
    quality: [],
    design: [],
    scriptLogs: [],
    scripts: null,
    event: {},
    dataProp: {},
    sysProp: {},
    script: null,
    facilityCurrent: null,
    variable: null,
    maxY: 0
  },
  actions: {
    setPropertyAll: ({ commit }, val) => {
      commit('SET_PROPERTY_ALL', val)
    },
    setProperty: ({ commit }, val) => {
      commit('SET_PROPERTY', val)
    },
    setDataProperty: ({ commit }, val) => {
      commit('SET_DATA_PROPERTY', val)
    },
    setSysProperty: ({ commit }, val) => {
      commit('SET_SYS_PROPERTY', val)
    },
    setEvent: ({ commit }, val) => {
      commit('SET_EVENT', val)
    },
    setEvents: ({ commit }, val) => {
      commit('SET_EVENTS', val)
    },
    clearFacilityData: ({ commit, state }) => {
      if (state.facilityCurrent?.id)
        commit('FILTER_SCRIPT_LOGS', state.facilityCurrent.id)
      commit('CLEAR_FACILITY_DATA')
    },
    setQuality: ({ commit }, val) => {
      commit('SET_QUALITY', val)
    },
    setDesignWeb({ commit }, val) {
      commit('SET_DESIGN_WEB', val)
    },
    setMaxY({ commit }, val) {
      commit('SET_MAX_Y', val)
    },
    setFacilityCurrent({ commit }, val) {
      commit('SET_FACILITY_CURRENT', val)
    },
    setScript({ commit }, val) {
      commit('SET_SCRIPT', val)
    },
    clearScript({ commit }) {
      commit('CLEAR_SCRIPT')
    },
    inputVariable: ({ commit }, val) => {
      commit('INPUT_VARIABLE', val)
    },
    addScriptLog: ({ commit }, val) => {
      console.warn(val)
      commit('ADD_SCRIPT_LOG', val)
    },
    clearScriptLogs({ commit }) {
      commit('CLEAR_SCRIPT_LOGS')
    },
    filterScriptLogs({ commit }, val) {
      commit('FILTER_SCRIPT_LOGS', val)
    },
    setShowFacilityMenu({ commit }) {
      commit('SHOW_FACILITIES_MENU')
    },
    setScriptChange({ commit }, val) {
      commit('SET_SCRIPT_CHANGE', val)
    },
    setScriptProcess({ commit }, val) {
      commit('SET_SCRIPT_PROCESS', val)
    },
    setActiveFlanges({ commit }, val) {
      commit('SET_ACTIVE_FLANGES', val)
    },
    setScripts({ commit }, val) {
      commit('SET_SCRIPTS', val)
    },
  },
  mutations: {
    SET_EDIT_MODE(state, editMode) {
      state.editMode = editMode;
    },
    SET_SHOW_COMPONENT_PANEL(state, showComponentPanel) {
      state.showComponentPanel = showComponentPanel;
    },
    SET_PROPERTY_ALL(state, propertyAll) {
      if (state.propertyAll?.length > 0) {
        state.propertyAll.length = 0;
      }
      state.propertyAll = propertyAll;
    },
    SET_PROPERTY(state, property) {
      if (state.property?.length > 0) {
        state.property.length = 0;
      }
      state.property = property;
    },
    SET_DATA_PROPERTY(state, dataProp) {
      state.dataProp = dataProp;
    },
    SET_SYS_PROPERTY(state, sysProp) {
      state.sysProp = sysProp;
    },
    SET_EVENT(state, event) {
      state.event = event;
    },
    SET_EVENTS(state, events) {
      state.events = events;
    },
    SET_ACTIVE_FLANGES(state, flanges) {
      state.activeFlanges = flanges;
    },
    CLEAR_FACILITY_DATA(state) {
      state.event = {};
      state.events = [];
      state.dataProp = {};
      state.property = [];
      state.propertyAll = [];
      state.facilityCurrent = null;
    },
    SET_QUALITY(state, quality) {
      state.quality = quality;
    },
    SET_DESIGN_WEB(state, design) {
      state.designWeb = design;
    },
    SET_MAX_Y(state, max) {
      state.maxY = max;
    },
    SET_FACILITY_CURRENT(state, facilityCurrent) {
      state.facilityCurrent = facilityCurrent;
    },
    SET_SCRIPT(state, script) {
      state.script = script;
    },
    CLEAR_SCRIPT(state) {
      state.script = null;
    },
    INPUT_VARIABLE(state, inputVariable) {
      state.inputVariable = inputVariable;
    },
    ADD_SCRIPT_LOG(state, scriptLogs) {
      if (typeof scriptLogs === 'object') {
        state.scriptLogs.unshift({ date: new Date().getTime(), message: scriptLogs.message, facilityId: scriptLogs.facilityId });
      } else {
        state.scriptLogs.unshift({ date: new Date().getTime(), message: scriptLogs, facilityId: state?.facilityCurrent?.id || 0 });
      }
    },
    CLEAR_SCRIPT_LOGS(state) {
      state.scriptLogs = [];
    },
    FILTER_SCRIPT_LOGS(state, facilityId) {
      state.scriptLogs = state.scriptLogs.filter((log) => log.facilityId != facilityId);
    },
    SHOW_FACILITIES_MENU(state) {
      state.showFacilitiesMenu = !state.showFacilitiesMenu;
    },
    SET_SCRIPT_CHANGE(state, scriptChange) {
      state.scriptChange = scriptChange;
    },
    SET_SCRIPT_PROCESS(state, scriptProcess) {
      state.scriptProcess = scriptProcess;
    },
    SET_SCRIPTS(state, scripts) {
      state.scripts = scripts;
    },
  },
  getters: {
    editMode: s => s?.editMode,
    propertyAll: s => s.propertyAll,
    property: s => s?.property ? s.property : [],
    events: s => s?.events ? s.events : [],
    event: s => s?.event ? s.event : {},
    dataProp: s => s?.dataProp ? s.dataProp : {},
    sysProp: s => s?.sysProp ? s.sysProp : {},
    showComponentPanel: s => s?.showComponentPanel,
    quality: s => s?.quality,
    designWeb: s => s?.designWeb ? s.designWeb : [],
    maxY: s => s?.maxY,
    facilityCurrent: s => s?.facilityCurrent,
    script: s => s?.script,
    activeFlanges: s => s?.activeFlanges,
    components: () => COMPONENTS || [],
    inputVariable: s => s?.inputVariable,
    scriptLogs: s => s.scriptLogs,
    showFacilitiesMenu: s => s.showFacilitiesMenu,
    scriptChange: s => s.scriptChange,
    scriptProcess: s => s.scriptProcess,
    scripts: s => s.scripts,
  },
}